export enum PaymentStatus {
  Unpaid = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  BankPaymentPending = 4
}

export const PaymentStatusLabel: Record<number, string> = {
  [PaymentStatus.Unpaid]: 'ÖDENMEDİ',
  [PaymentStatus.Pending]: 'BEKLEMEDE', // mavi
  [PaymentStatus.Approved]: 'ONAYLANDI', // yeşil
  [PaymentStatus.Rejected]: 'REDDEDİLDİ', // kırmızı
  [PaymentStatus.BankPaymentPending]: 'HAVALE BEKLENİYOR', 
};
